// ============================================================
// Custom analytics events not covered by Shopify's standard
// customer events (e.g. GA4 "select_item").
//
// Detects clicks on product cards rendered via
// snippets/product-card.liquid (identified by the
// [data-select-item] attribute) and publishes a "select_item"
// custom event that the GTM custom pixel (medivon-custom-piksel.js)
// subscribes to and forwards to the dataLayer.
//
// Also detects clicks on the "show all photos" button rendered via
// snippets/product-media-gallery.liquid (identified by the
// [data-desktop-show-more-photos] attribute) and publishes a
// "show_more_photos" custom event.
// ============================================================
(() => {
  if (!window.Shopify || typeof window.Shopify.analytics === 'undefined') return;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link) {
      const card = link.closest('[data-select-item]');
      if (card) {
        let payload;
        try {
          payload = JSON.parse(card.getAttribute('data-select-item'));
        } catch (error) {
          return;
        }

        window.Shopify.analytics.publish('select_item', payload);
      }
      return;
    }

    const showMoreButton = event.target.closest('[data-desktop-show-more-photos]');
    
    if (showMoreButton) {
      let payload;
      try {
        payload = JSON.parse(showMoreButton.getAttribute('data-show-more-photos-payload'));
      } catch (error) {
        return;
      }

      window.Shopify.analytics.publish('show_more_photos', payload);
    }
  });
})();
